var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.notes),function(note,key){return _c('li',{key:key,staticClass:"mb-1",class:_vm.getClass(note)},[_vm._v(_vm._s(note.message))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }